<template>
	<div>
		<h5 class="resume-title">
			{{$t('account/bookings.Your documents')}}
		</h5>

		<div 
		class="list-group list-group-flush">
			
			<list-group-item
			:key="'document-'+index"
			v-for="(item, index) in documents">
				<i class="fe fe-file mr-3"></i>
				{{item.name|str_limit(30)}}

				<small class="ml-4 text-muted">
					{{$getSize(item.file.size)}}
				</small>
			</list-group-item>

			<div 
			v-if="!documents.length"
			class="alert bg-lighten p-3 rounded text-center small">
				{{$t('account/bookings.Empty document for the moment')}}
			</div>

		</div> <!-- /.list-group -->

	</div>
</template>

<script>

	import {mapState} from 'vuex'

	export default {

		computed: {
			...mapState({
				booking: state => state.booking,
				documents: state => state.booking.documents,
			})
		}

	}
</script>